export const filterSolutions = (list: (DataProfileCard | APISolution | APIBlueprint)[], onlySolutions = false) => {
    return list.filter((item: DataProfileCard | APISolution | APIBlueprint) => {
        return 'MktplaceSolutionName' in item === onlySolutions;
    });
};

export const filterDatasetsSolutionsBlueprints = (list: (DataProfileCard | APISolution | APIBlueprint)[], onlySolutions = false, onlyBlueprints = false) => {
    return list.filter((item: DataProfileCard | APISolution | APIBlueprint) => {
        if (onlySolutions && !onlyBlueprints) {
            return 'MktplaceSolutionName' in item === onlySolutions;
        }
        if (!onlySolutions && onlyBlueprints) {
            return 'MarketplaceBlueprintName' in item === onlyBlueprints;
        }
        return 'MarketplaceBlueprintName' in item === onlyBlueprints && 'MktplaceSolutionName' in item === onlySolutions;
    });
};
